import {Ticker} from '../features/ticker';
import {Slider} from '../features/slider';
import {isDesktop} from '../util/media-query';

const selectors = {
  slide: '[data-slide]',
  slider: '[data-slider]',
};

const attributes = {
  slide: 'data-slide',
  stop: 'data-stop',
  style: 'style',
  targetReferrer: 'data-target-referrer',
};

class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.locationPath = location.href;

    this.slides = this.querySelectorAll(selectors.slide);
    this.slider = this.querySelector(selectors.slider);
    this.enableSlider = isDesktop();
    this.initSliderEvent = (event) => this.initSlider(event);
  }

  connectedCallback() {
    this.removeAnnouncement();

    if (this.slider) {
      this.initSliders();
    }

    this.addEventListener('theme:block:select', (e) => {
      this.onBlockSelect(e);
    });

    this.addEventListener('theme:block:deselect', (e) => {
      this.onBlockDeselect(e);
    });

    document.dispatchEvent(new CustomEvent('theme:announcement:init', {bubbles: true}));
  }

  /**
   * Delete announcement which has a target referrer attribute and it is not contained in page URL
   */
  removeAnnouncement() {
    for (let index = 0; index < this.slides.length; index++) {
      const element = this.slides[index];

      if (!element.hasAttribute(attributes.targetReferrer)) {
        continue;
      }

      if (this.locationPath.indexOf(element.getAttribute(attributes.targetReferrer)) === -1 && !window.Shopify.designMode) {
        element.parentNode.removeChild(element);
      }
    }
  }

  /**
   * Init slider
   */
  initSliders() {
    this.initSlider();
    document.addEventListener('theme:resize:width', this.initSliderEvent);

    this.addEventListener('theme:slider:loaded', () => {
      this.querySelectorAll(selectors.tickerBar)?.forEach((ticker) => {
        ticker.dispatchEvent(new CustomEvent('theme:ticker:refresh'));
      });
    });
  }

  initSlider() {
    const isDesktopView = isDesktop();
    const isMobileView = !isDesktopView;

    if ((isDesktopView && this.enableSlider) || (isMobileView && !this.enableSlider)) {
      this.slider.flkty?.destroy();

      if (isDesktopView && this.enableSlider) {
        this.enableSlider = false;
      } else if (isMobileView && !this.enableSlider) {
        this.enableSlider = true;
      }

      this.slider = new Slider(this, this.querySelector(selectors.slider));
      this.slider.flkty?.reposition();
    }
  }

  onBlockSelect(e) {
    if (this.slider) {
      this.slider.onBlockSelect(e);
    }
  }

  onBlockDeselect(e) {
    if (this.slider) {
      this.slider.onBlockDeselect(e);
    } else {
      this.toggleTicker(e, false);
    }
  }

  disconnectedCallback() {
    document.removeEventListener('theme:resize:width', this.initSliderEvent);
    document.removeEventListener('theme:resize:width', this.tickerResizeEvent);
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar);
}

if (!customElements.get('ticker-bar')) {
  customElements.define('ticker-bar', Ticker);
}
